import React, { useEffect, useMemo, useState } from "react";
import { getRoles } from "common/services/users.service";
import { normalize } from "common/lib/normalize";
import { FilterValueSelect } from "Components/Common/TableFilters";

type RoleFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const RoleFilter = ({ onChange, value }: RoleFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await getRoles({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });

        setData(normalize(response.roles));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <FilterValueSelect
      id="roleFilter"
      placeholder="Select Role"
      value={value}
      onChange={onChange}
      options={options}
      isLoading={loading}
    />
  );
};

export default RoleFilter;
